import NewsListModule from './NewsListModule';

export default NewsListModule;
